import { Link } from "react-router-dom";
import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import { useOrganizations } from "@/api/hooks/organizations";

function formatDate(iso: string | null): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString();
}

export default function OrganizationsList() {
  const { data, isLoading, error } = useOrganizations();

  if (isLoading) return <CircularProgress />;
  if (error) return <Alert severity="error">{error.message}</Alert>;

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
        <Typography variant="h5">Organizations</Typography>
        <Link to="new" style={{ textDecoration: "none" }}>
          <Button variant="contained" startIcon={<Add />}>
            New
          </Button>
        </Link>
      </Box>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Display ID</TableCell>
              <TableCell align="right">Sites</TableCell>
              <TableCell>Master MSA</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {(data ?? []).map((org) => (
              <TableRow key={org.id} hover>
                <TableCell>
                  <Link to={org.id}>{org.name}</Link>
                </TableCell>
                <TableCell sx={{ fontFamily: "ui-monospace, Menlo, monospace" }}>
                  {org.display_id ?? "—"}
                </TableCell>
                <TableCell align="right">
                  <Chip
                    size="small"
                    label={org.site_count}
                    color={org.site_count > 0 ? "primary" : "default"}
                    variant={org.site_count > 0 ? "filled" : "outlined"}
                  />
                </TableCell>
                <TableCell>{formatDate(org.master_msa_signed_at)}</TableCell>
                <TableCell align="right">
                  <Link to={`${org.id}/edit`}>Edit</Link>
                </TableCell>
              </TableRow>
            ))}
            {(data ?? []).length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={5}
                  align="center"
                  sx={{ py: 4, color: "text.secondary" }}
                >
                  No organizations yet.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
